import React from 'react'
import { useTranslation } from 'react-i18next'

import SubscriptionDetail from 'adminDashboard/companySettings/subscription/components/SubscriptionDetail'
import { Col, Row } from 'antd'

import { RenewalGroupHealthPlanInformationDTO } from 'core/application/adminDashboard/benefitRenewal/renewalGroupHealthPlanInformation/renewalGroupHealthPlanInformation'

import { parseZoneMonthYearDashFormat } from 'common/dateFormatters'

interface ViewGroupHealthPlanInformationProps {
  groupHealthPlanDetails: RenewalGroupHealthPlanInformationDTO
}

const ViewGroupHealthPlanInformation: React.FC<ViewGroupHealthPlanInformationProps> = ({ groupHealthPlanDetails }) => {
  const { t: translate } = useTranslation()
  return (
    <>
      <Row>
        <Col md={12}>
          <SubscriptionDetail
            title={translate('admin-signup.company-details.health-plan.insurance-carrier-label')}
            description={groupHealthPlanDetails.insuranceCarrier}
          />
        </Col>
        <Col md={12}>
          <SubscriptionDetail
            title={translate('admin-signup.company-details.health-plan.insurance-plan-label')}
            description={groupHealthPlanDetails.planName}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <div className="mt-4">
            <p className="color-gray-7">{translate('admin-dashboard.benefit-details.summary.class-waiting-period')}</p>
            <p>
              {groupHealthPlanDetails.waitingPeriod}{' '}
              {translate('admin-signup.company-details.health-plan.waiting-period-label')}
            </p>
          </div>
        </Col>
        <Col md={12}>
          <div className="mt-4">
            <p className="color-gray-7">{translate('admin-signup.company-details.health-plan.start-date-label')}</p>
            <p>{parseZoneMonthYearDashFormat(groupHealthPlanDetails.startDate)}</p>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default ViewGroupHealthPlanInformation
